module.exports = __webpack_public_path__ + "officialStatic/img/productBg.6d6372e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/productBg.png
// module id = Pn2g
// module chunks = 0